import React from 'react';
import { Paragraph2 } from '../../theme/styles';
import './Checkbox.css';

/*
 * <Checkbox /> component accepts props of:
 * option: {
 *    key: "",
 *    text: "",
 *    value: "",
 *    checked: true/false,
 *    count: "",
 *    hideCount: true/false/null,
 *    indeterminate: true/false/null,
 * }
 *
 * cellClick={} -- cellClick event
 */

export class Checkbox extends React.PureComponent {
    componentDidMount() {
        if (this.inputRef && this.props.option.indeterminate) {
            this.inputRef.indeterminate = true;
        }
    }

    componentDidUpdate(previousProps) {
        if (this.inputRef && (previousProps.indeterminate !== this.props.option.indeterminate)) {
            this.inputRef.indeterminate = this.props.option.indeterminate;
        }
    }

    render() {
        const {
            option,
            className,
            cellClick,
            size,
            showLockIconOnDisabled,
        } = this.props;

        const {
            key,
            text,
            subText,
            rightLozenge,
            rightLozengeClass = '',
            checked,
            count,
            hideCount,
            indeterminate,
            disabled,
        } = option;

        return (
            <div
                className={[className, disabled ? 'disabled' : ''].join(' ')}
                style={Paragraph2}
                role="checkbox"
                tabIndex={key || -1}
                aria-checked={checked}
                onClick={!disabled && cellClick ? () => cellClick(option) : null}
            >
                <input
                    className={showLockIconOnDisabled ? 'checkbox-input input-locked' : `dropdownCheckboxInputContainer checkbox-input ${size ?? ''}`}
                    data-testid="checkbox-button"
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    // indeterminate={indeterminate}
                    ref={(input) => {
                        if (input && indeterminate) {
                            this.inputRef = input;
                        }
                    }}
                    readOnly={!!cellClick}
                />
                {text && !subText ? <div className="dropdownCheckboxLabel">{text}</div> : null}

                {text && subText
                    ? (
                        <div className={['dropdownCheckboxLabel', rightLozenge ? 'spaceBetween' : ''].join(' ').trim()}>
                            {text}
                            {subText ? <span className="dropdownCheckboxSubText">{subText}</span> : null}
                            {rightLozenge ? <div className={['lozenge', rightLozengeClass].join(' ').trim()}>{rightLozenge}</div> : null}
                        </div>
                    )
                    : null}
                {count && !hideCount ? <div className="dropdownCheckboxCount">{`(${count})`}</div> : null}
            </div>
        );
    }
}

export default Checkbox;
